// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sjR6","question":"styles_question__3C8eS","inputVisibleButton":"styles_inputVisibleButton__2c3X0","note":"styles_note__1V6nX"};